import * as signalR from '@microsoft/signalr';

const { REACT_APP_SIGNALR } = process.env;

export const OpenConnection = async (socketConnection) => {
  await socketConnection
    .start()
    .then((resp) => console.log(resp, 'Sucesso!'))
    .catch((error) => console.log(error, 'Erro!'));
};

export const BuildConnection = (hubName) => {
  const socketConnection = new signalR.HubConnectionBuilder()
    .configureLogging(signalR.LogLevel.Debug)
    .withUrl(`${REACT_APP_SIGNALR}/${hubName}`)
    .build();

  socketConnection.keepAliveIntervalInMilliseconds = 1000 * 60 * 100; // 100 minutes
  socketConnection.serverTimeoutInMilliseconds = 1000 * 60 * 100; // 100 minutes

  return socketConnection;
};

export const CloseConnection = async (socketConnection) => {
  await socketConnection
    .stop()
    .then(() => {})
    .catch((error) => {
      console.log(error);
    });
};
